/* Carrusel de productos: arrastrar con el raton y avance
   automatico opcional. Se detiene en cuanto el visitante
   interactua o pasa el raton por encima. */
if (!customElements.get('product-slider')) {
  customElements.define(
    'product-slider',
    class ProductSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.ps__track');
        if (!this.track) return;

        this.setupDrag();

        if (this.dataset.autoplay === 'true') {
          this.speed = (parseInt(this.dataset.speed, 10) || 4) * 1000;
          this.setupAutoplay();
        }
      }

      disconnectedCallback() {
        this.stop();
      }

      step() {
        const item = this.track.querySelector('.ps__item');
        if (!item) return 0;
        const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
        return item.getBoundingClientRect().width + gap;
      }

      setupDrag() {
        let down = false;
        let startX = 0;
        let startScroll = 0;
        let moved = 0;

        this.track.addEventListener('pointerdown', (event) => {
          if (event.pointerType === 'touch') return;
          down = true;
          moved = 0;
          startX = event.clientX;
          startScroll = this.track.scrollLeft;
        });

        this.track.addEventListener('pointermove', (event) => {
          if (!down) return;
          const delta = event.clientX - startX;
          moved = Math.abs(delta);
          if (moved > 4) {
            this.track.classList.add('is-dragging');
            this.track.scrollLeft = startScroll - delta;
          }
        });

        const release = () => {
          down = false;
          window.setTimeout(() => this.track.classList.remove('is-dragging'), 0);
        };

        this.track.addEventListener('pointerup', release);
        this.track.addEventListener('pointerleave', release);
        this.track.addEventListener('pointercancel', release);
      }

      setupAutoplay() {
        const pause = () => this.stop();
        const resume = () => this.start();

        this.addEventListener('pointerenter', pause);
        this.addEventListener('pointerleave', resume);
        this.addEventListener('focusin', pause);
        this.addEventListener('focusout', resume);
        this.track.addEventListener('pointerdown', pause);
        this.track.addEventListener('touchstart', pause, { passive: true });

        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.start();
      }

      start() {
        this.stop();
        this.timer = window.setInterval(() => this.advance(), this.speed);
      }

      stop() {
        if (this.timer) window.clearInterval(this.timer);
        this.timer = null;
      }

      advance() {
        if (!this.isConnected || !this.track) return this.stop();

        const max = this.track.scrollWidth - this.track.clientWidth;
        const next = this.track.scrollLeft + this.step();

        this.track.scrollTo({
          left: next > max - 2 ? 0 : next,
          behavior: 'smooth',
        });
      }
    }
  );
}
